import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { patchApi } from 'views/services/api';
import { toast } from 'react-toastify';

const DeletePackage = ({ open, handleClose, id, getAllPackagesData }) => {
  //handle delete function-------------
  const handleDelete = async () => {
    try {
      const result = await patchApi(`api/packages/delete/${id}`, id);
      if (result && result.status === 200) {
        getAllPackagesData();
        toast.success('Package Deleted Successfully');
        handleClose();
      }
    } catch (error) {
      console.log(error);
      toast.error('Cannot Delete Package');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Delete Package</DialogTitle>
      <DialogContent>
        <p>Are you sure you want to delete this Package?</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleDelete} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeletePackage.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  id: PropTypes.string,
  getAllPackagesData: PropTypes.func
};
export default DeletePackage;
